var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0.5H2.5C1.25912 0.5 0.25 1.50912 0.25 2.75V16.25C0.25 17.4909 1.25912 18.5 2.5 18.5H20.5C21.7409 18.5 22.75 17.4909 22.75 16.25V2.75C22.75 1.50912 21.7409 0.5 20.5 0.5ZM7.80438 5C9.09925 5 10.0544 5.95512 10.0544 7.25C10.0544 8.54488 9.09925 9.5 7.80438 9.5C6.5095 9.5 5.55438 8.54488 5.55438 7.25C5.55438 5.95512 6.50838 5 7.80438 5ZM11.9838 14H3.625V13.4769C3.625 11.9323 5.5105 10.3438 7.80438 10.3438C10.0983 10.3438 11.9838 11.9323 11.9838 13.4769V14ZM19.375 12.875H14.875V10.625H19.375V12.875ZM19.375 8.375H13.75V6.125H19.375V8.375Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.e0561c4809cb1bd2824f5480c2a014c3.svg";
export { ForwardRef as ReactComponent };